// extracted by mini-css-extract-plugin
export default {"content":"brand-page_content__4x+yW"};